// Sidebar entries for one navigation section: consecutive items naming the same `group` fold into
// one collapsible entry (e.g. "Customised reports" → its report pages); other items stay as they
// are. Items stay flat in the navigation config, so the menu editor keeps moving and renaming them.
import type { NavItem } from '../app/types';

export type NavEntry = { kind: 'item'; item: NavItem } | { kind: 'group'; label: string; icon: string; items: NavItem[] };

export function navEntries(items: NavItem[]): NavEntry[] {
  const out: NavEntry[] = [];
  for (const item of items) {
    const last = out[out.length - 1];
    if (item.group && last?.kind === 'group' && last.label === item.group) last.items.push(item);
    else if (item.group) out.push({ kind: 'group', label: item.group, icon: item.groupIcon ?? 'grid', items: [item] });
    else out.push({ kind: 'item', item });
  }
  return out;
}
